import { render, staticRenderFns } from "./TextSearchResultContainer.vue?vue&type=template&id=57b0b022"
import script from "./TextSearchResultContainer.vue?vue&type=script&lang=js"
export * from "./TextSearchResultContainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports